import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";
import "./index.css";
import { AppProvider } from "./store/AppStore";
import { App } from "./App";
import { ErrorBoundary } from "./ui/components/ErrorBoundary";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {/* Root-Boundary: selbst ein Fehler in Layout/Store zeigt eine Karte,
        nie einen schwarzen Bildschirm. Die per-Route-Boundary in App hält
        zusätzlich Kopf/Navigation, wenn nur eine Seite fällt. */}
    <ErrorBoundary>
      <AppProvider>
        <HashRouter>
          <App />
        </HashRouter>
      </AppProvider>
    </ErrorBoundary>
  </StrictMode>,
);
